"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const description = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "htx", code: "coronarography_summary" })
    .tag({ vocab: "snomed", code: "371534008" })
    .tag({ vocab: "loinc", code: "55112-7" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ description })
    .tag({ vocab: "snomed", code: "33367005" })
    .tag({ vocab: "loinc", code: "80994-7" })
    .tag({ vocab: "snomed", code: "243806009" });
